module.exports = __webpack_public_path__ + "static/media/icon_cps.99b087b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_cps.svg
// module id = 678
// module chunks = 0